export enum EStatisticsTab {
    AllBets = "allBets",
    MyBets = "myBets",
    TopBets = "topBets"
}

export enum EStatisticsTimespan {
    Today = "day",
    Week = "week",
    Month = "month",
    Year = "year"
}
